import { InjectionToken } from '@angular/core'
import { ActionReducerMap, MetaReducer } from '@ngrx/store'

export const getReducers = (): ActionReducerMap<any> => ({})

export const REDUCER_TOKEN = new InjectionToken<ActionReducerMap<any>>('global')
export const metaReducers: MetaReducer<any>[] = []
